export const apiUrl = window.location.origin+'/api/';
export const scroll = '200';